export function getAll() {
  return [
    {
      value: 0,
      name: "none",
      text: "無",
    },
    {
      value: 1,
      name: "cellphone",
      text: "手機載具",
    },
    {
      value: 2,
      name: "nature",
      text: "自然人憑證",
    },
    {
      value: 3,
      name: "donate",
      text: "捐贈",
    },
    {
      value: 4,
      name: "member",
      text: "會員載具",
    },
  ];
}
